import { render, staticRenderFns } from "./CDEKHead.vue?vue&type=template&id=7152f239&scoped=true"
import script from "./CDEKHead.vue?vue&type=script&lang=js"
export * from "./CDEKHead.vue?vue&type=script&lang=js"
import style0 from "./CDEKHead.vue?vue&type=style&index=0&id=7152f239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152f239",
  null
  
)

export default component.exports